import { GetSiteSetupQuery, PhotosInstructionFragmentFragment } from 'data/__generated__';

import { SectionContainer } from 'components/DetailsView/Section';
import { TotemGallery } from 'components/TotemGallery';
import styled from 'styled-components';
import { isPhotosInstruction } from '../utils/typePredicates';
import { separatePhotosByStartEnd } from 'pages/Deliveries/utils/photoUtils';
export const PhotosSection = ({ siteSetup }: { siteSetup: NonNullable<GetSiteSetupQuery['getSiteSetup']> }) => {
    const storePhotosInstructions = siteSetup.microstoreColumnGroupSetups
        .flatMap(({ instructionsAfterColumns, instructionsBeforeColumns, microstoreColumnSetups }) => [
            ...instructionsBeforeColumns,
            ...microstoreColumnSetups.flatMap(({ instructions }) => instructions),
            ...instructionsAfterColumns,
        ])
        .filter((instruction) => isPhotosInstruction(instruction)) as PhotosInstructionFragmentFragment[];

    const freefoodPhotosInstructions =
        (siteSetup.freefoodSetup?.instructions?.filter((instruction) =>
            isPhotosInstruction(instruction),
        ) as PhotosInstructionFragmentFragment[]) ?? [];

    const storePhotos = storePhotosInstructions.flatMap((instruction) => instruction.controlPhotos);
    const freefoodPhotos = freefoodPhotosInstructions.flatMap((instruction) => instruction.controlPhotos);

    const { startPhotos: storeStartPhotos, endPhotos: storeEndPhotos } = separatePhotosByStartEnd(storePhotos);
    const { startPhotos: freefoodStartPhotos, endPhotos: freefoodEndPhotos } = separatePhotosByStartEnd(freefoodPhotos);

    return (
        <SectionContainer title="Toutes les Photos" isInitiallyOpen>
            <>
                {freefoodStartPhotos.length > 0 && (
                    <>
                        <Title>Photos Freefood - Début du rangement</Title>
                        <TotemGallery images={freefoodStartPhotos} />
                    </>
                )}
                {freefoodEndPhotos.length > 0 && (
                    <>
                        <Title>Photos Freefood - Fin du rangement</Title>
                        <TotemGallery images={freefoodEndPhotos} />
                    </>
                )}
                {storeStartPhotos.length > 0 && (
                    <>
                        <Title>Photos Store - Début du rangement</Title>
                        <TotemGallery images={storeStartPhotos} />
                    </>
                )}
                {storeEndPhotos.length > 0 && (
                    <>
                        <Title>Photos Store - Fin du rangement</Title>
                        <TotemGallery images={storeEndPhotos} />
                    </>
                )}
            </>
        </SectionContainer>
    );
};

const Title = styled.div`
    margin-top: 15px;
    font-weight: bold;
    font-size: 18px;
`;
